import { createSvgComponent } from "../../icon/createSvgComponent";
import GiftBoxRed from "@core/icon/assets/gift-box-red.svg";
export default createSvgComponent(GiftBoxRed);